import { useEffect, useState } from "react";
import styled from "styled-components";
// import Brands from "../../component/brands/Brands";

export default  function Footer() {

    const [branch, setBranch] = useState([]); // ESTO ES PARA USAR CON API DE Branch.

    useEffect(() => {
        fetchBranch(); // ESTO ES PARA USAR CON API DE Branch.
    }, []);

    // ESTO ES PARA USAR CON API DE Branch.
    const fetchBranch = async () => {
        try {
            const response = await fetch('https://admin.leiten.com.ar/api/getAllBranches');
            if (response.ok) {
                const data = await response.json();
                const branches = data.slice(1); // Excluye el primer elemento
                setBranch(branches); // Establece Sucursales obtenidos desde la API en el estado
            } else {
                throw new Error('Network response was not ok');
            }
        } catch (error) {
            console.error('Error fetching currency:', error);
        }
    };

    return(
        <StyledFooter>
            {/* <div className="container">
                <div className="linea"></div>
                <Brands/>
            </div> */}
            <footer className="containerFooter">
                <div className="contenFooter container">
                    <div className="contenInfo">
                        <h5>Comuníquese con Alusystem®</h5>
                        <div className="row">
                            <div className="col-6">
                                <ul style={{paddingLeft: '0px'}}>
                                    {branch.slice(0, Math.ceil(branch.length / 2)).map(objeto => (
                                        <li className="contenSucursal" key={objeto.id}>
                                            <p className='title'><strong>{objeto.nombre}</strong></p>
                                            <p>{objeto.direccion} - {objeto.localidad} - {objeto.prov.nombre}</p>
                                            <p>{objeto.tel_fijo} / {objeto.tel_movil}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="col-6">
                                <ul style={{paddingLeft: '0px'}}>
                                    {branch.slice(Math.ceil(branch.length / 2)).map(objeto => (
                                        <li className="contenSucursal" key={objeto.id}>
                                            <p className='title'><strong>{objeto.nombre}</strong></p>
                                            <p>{objeto.direccion} - {objeto.localidad} - {objeto.prov.nombre}</p>
                                            <p>{objeto.tel_fijo} / {objeto.tel_movil}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </StyledFooter>
    )
};

const StyledFooter = styled.footer`
    .containerFooter{
        background-image: url('../../../assets/img/footer.jpg');
        @media(min-width: 768px){
            background-image: no-repeat;
            background-position: center;
            height: auto;
        }
    }
    .contenFooter{
        color: #fff;
        display: flex;
        justify-content: flex-end;
    }
    .contenInfo{
        background-color: var(--colorGRisTerciario);
        padding: 2rem;
        opacity: 0.9;
        @media(min-width: 768px) {
            padding: 4rem;
        }
    }
    .containerSucursal{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }
    .contenSucursal p{
        color: #fff;
        font-size: 0.8rem;
        padding: 0.5rem;
    }
    .title {
        margin-top: 40px;
    }
    .title strong{
        font-size: 1.2rem;
    }
    strong, h5{
        color: #fff;
    }
`